import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class AccordionService {
  private _expanded$: BehaviorSubject<boolean>;

  get expanded$(): Observable<boolean> {
    return this._expanded$.asObservable();
  }

  initPanel(expanded: boolean): void {
    this._expanded$ = new BehaviorSubject(expanded);
  }

  toggle(expanded: boolean): void {
    this._expanded$.next(expanded);
  }
}
